// Active les fonctionnalités saisonnières seulement pendant les campagnes concernées.
// Le code Noël reste présent dans le projet, mais il n'est plus exposé côté utilisateur.
export const FEATURES = {
  santaExperience: false,
  seasonalTheme: false,
};
